import { createAction, props } from '@ngrx/store';
import { ResponseDocumentSignature, RequestDocumentSignature } from '../../shared/interfaces';
import { DocumentSignatureTypes } from '../../shared/enums';


export const getDocumentSignature = createAction(
    DocumentSignatureTypes.DOCUMENT_SIGNATURE,
    props<{ request: RequestDocumentSignature}>()
);

export const getDocumentSignatureSucess = createAction(
    DocumentSignatureTypes.DOCUMENT_SIGNATURE_SUCCESS,
    props<{ response: ResponseDocumentSignature }>()
);

export const getDocumentSignatureError = createAction(
    DocumentSignatureTypes.DOCUMENT_SIGNATURE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    DocumentSignatureTypes.CLEAN_STATE
);
